import { Link } from "react-router-dom";
import { t } from "@/core/composition/lexicon";

interface ModuleConsoleFooterProps {
  consoleRoute: string;
  moduleLabel: string;
}

export function ModuleConsoleFooter({ consoleRoute, moduleLabel }: ModuleConsoleFooterProps) {
  return (
    <p className="small text-muted mt-3 mb-0">
      Interface native ITaaS Hospitol · source {moduleLabel}.{" "}
      <Link to={consoleRoute}>{t("action.advancedModule")}</Link> ({moduleLabel} complet).
    </p>
  );
}
